import React from 'react';
import { Box, Typography, Card, CardContent, Alert } from '@mui/material';
import { Star, Construction, HelpOutline } from '@mui/icons-material';

export function TipsTab() {
  return (
    <Box>
      <Card>
        <CardContent sx={{ textAlign: 'center', py: 8 }}>
          <Construction sx={{ fontSize: 80, color: 'text.secondary', mb: 3 }} />
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            Tips Management
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 600, mx: 'auto' }}>
            Manage driver tips from satisfied renters. Track tip distribution, commission, and payout integration.
          </Typography>

          <Alert severity="info" icon={<HelpOutline />} sx={{ maxWidth: 700, mx: 'auto', textAlign: 'left', mb: 3 }}>
            <Typography variant="body2" gutterBottom>
              <strong>Business Decision Required:</strong>
            </Typography>
            <Typography variant="body2">
              Determine if PolarRide will implement a tipping system for drivers. This feature requires:
            </Typography>
            <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 0 }}>
              <li>Platform policy on tip handling (pass-through vs commission)</li>
              <li>Integration with mobile apps for renter tip interface</li>
              <li>Automatic tip distribution to driver payouts</li>
            </Typography>
          </Alert>

          <Alert severity="warning" sx={{ maxWidth: 700, mx: 'auto', textAlign: 'left' }}>
            <Typography variant="body2" gutterBottom>
              <strong>Required Backend Endpoints:</strong>
            </Typography>
            <Typography variant="body2" component="ul" sx={{ pl: 2, mb: 0 }}>
              <li>GET /api/v1/admin/tips - List all tips with driver/renter details</li>
              <li>GET /api/v1/admin/tips/stats - Tip analytics and trends</li>
              <li>POST /api/v1/admin/tips/settings - Configure tip policies</li>
            </Typography>
          </Alert>

          <Box sx={{ mt: 4 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Potential Features:
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mt: 2 }}>
              <Card variant="outlined" sx={{ p: 2, minWidth: 200 }}>
                <Star sx={{ color: 'primary.main', mb: 1 }} />
                <Typography variant="body2" fontWeight="600">Tip Analytics</Typography>
                <Typography variant="caption" color="text.secondary">
                  Track average tips, top earners, and trends
                </Typography>
              </Card>
              <Card variant="outlined" sx={{ p: 2, minWidth: 200 }}>
                <Star sx={{ color: 'primary.main', mb: 1 }} />
                <Typography variant="body2" fontWeight="600">Auto-Distribution</Typography>
                <Typography variant="caption" color="text.secondary">
                  Tips automatically added to driver payouts
                </Typography>
              </Card>
              <Card variant="outlined" sx={{ p: 2, minWidth: 200 }}>
                <Star sx={{ color: 'primary.main', mb: 1 }} />
                <Typography variant="body2" fontWeight="600">Commission Settings</Typography>
                <Typography variant="caption" color="text.secondary">
                  Configure if platform takes commission on tips
                </Typography>
              </Card>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
